import {Component, Input, OnInit} from '@angular/core';
import {LoaningService} from '../../common/services/loaning/loaning.service';
import {Loaning} from '../../common/services/loaning/loaning.model';

@Component({
  selector: 'app-loaning-state-chip',
  templateUrl: './loaning-state-chip.component.html',
  styleUrls: ['./loaning-state-chip.component.scss']
})
export class LoaningStateChipComponent implements OnInit {
  @Input() loaning: Loaning;
  @Input() align: 'start' | 'end' = 'start';
  constructor(public loaningSvc: LoaningService) { }

  ngOnInit(): void {
  }
  flexAlign() {
    return this.align === 'start' ? 'flex-start' : 'flex-end';
  }
}
